import Search from "./Search";
import "./styles.css";

function App() {
  return (
    <div>
      <Search />
    </div>
  );
}

export default App;
